import React from 'react';

/**
 * Reusable Card component for service categories.
 * @param {object} props - Component props
 * @param {string} props.name - Category name
 * @param {React.Component} props.Icon - Lucide icon component
 * @returns {JSX.Element}
 */
interface ServiceCategoryCardProps {
  id: string; // Add id prop
  name: string;
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  onClick: (categoryId: string) => void; // Add onClick prop
}

const ServiceCategoryCard: React.FC<ServiceCategoryCardProps> = ({ id, name, Icon, onClick }) => (
  <button
    className="flex flex-col items-center justify-center p-4 bg-gray-800 shadow-2xl shadow-teal-900/50 rounded-3xl h-36 transform transition duration-200 hover:scale-[1.02] active:scale-[0.98] ring-2 ring-transparent hover:ring-teal-500"
    onClick={() => onClick(id)} // Pass id to onClick
  >
    <div className="p-4 rounded-xl mb-3">
      <Icon className="w-12 h-12 text-teal-400 stroke-2" />
    </div>
    <span className="text-gray-100 font-semibold text-base">{name}</span>
  </button>
);

export default ServiceCategoryCard;
